export default "__VITE_ASSET__563f1dfa__"